import React from "react";
import { Divider } from "antd";
import styles from "./eventHistoryHeader.module.css";

export const EventHistoryHeader = () => {
    return (
        <div className={styles.eventHistoryHeaderContainer}>
            Event History
            <Divider className={styles.divider} />
        </div>
    )
}
